export default __webpack_public_path__ + "static/media/step-2.cb97b3a1.svg";